const semanticClassNames = {
  root: 'checkbox',
  label: 'checkbox__label',
  icon: 'checkbox__icon',
  input: 'checkbox__input',
} as const;

export default semanticClassNames;
